/**
 * Abstract base class for analytics providers
 */
export default class AnalyticsProvider {
  constructor(config = {}) {
    if (new.target === AnalyticsProvider) {
      throw new Error(
        'AnalyticsProvider is abstract and cannot be instantiated directly',
      );
    }

    this.config = config;
    this.isInitialized = false;
  }

  /**
   * Initialize the analytics provider
   * @abstract
   */
  async initialize() {
    throw new Error('initialize() must be implemented by subclass');
  }

  /**
   * Track an event
   * @abstract
   * @param {string} eventName - Name of the event
   * @param {Object} eventData - Event parameters
   */
  // eslint-disable-next-line no-unused-vars
  trackEvent(eventName, eventData) {
    throw new Error('trackEvent() must be implemented by subclass');
  }

  /**
   * Set user properties
   * @abstract
   * @param {Object} properties - User properties
   */
  // eslint-disable-next-line no-unused-vars
  setUserProperties(properties) {
    throw new Error('setUserProperties() must be implemented by subclass');
  }

  /**
   * Check if provider is available and properly configured
   * @abstract
   * @returns {boolean}
   */
  isAvailable() {
    throw new Error('isAvailable() must be implemented by subclass');
  }

  /**
   * Get provider name
   * @abstract
   * @returns {string}
   */
  getName() {
    throw new Error('getName() must be implemented by subclass');
  }

  /**
   * Transform event data to provider-specific format
   * @abstract
   * @param {Object} eventData - Raw event data
   * @returns {Object} - Transformed event data
   */
  // eslint-disable-next-line no-unused-vars
  transformEventData(eventData) {
    throw new Error('transformEventData() must be implemented by subclass');
  }
}
